<template>
  <div id="temp-list" class="flex flex1 justify-start row">
    <img
      v-for="(item, index) in templateList"
      :key="index"
      :alt="item.name"
      :src="item.url"
      :class="templateName === item.name ? 'tem__image__active' : ''"
      class="temp__image"
      @click="selectTemplate(item.name)"
    />
  </div>
</template>

<script>
// let _this = void 0
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'TemplateList',
  components: {},
  filters: {},
  mixins: [],
  props: {},
  data() {
    return {
      templateList: [
        {
          name: '模板1',
          url: require('@/assets/template/qrcode_temp_0.svg'),
        },
        {
          name: '模板2',
          url: require('@/assets/template/qrcode_temp_1.svg'),
        },
      ],
    }
  },
  computed: {
    ...mapState('editor', {
      templateName: state => state.templateName,
    }),
  },
  watch: {},
  created() {
    //    _this = this
  },
  mounted() {},
  methods: {
    ...mapMutations('editor', ['setTemplate']),
    /*
     * 选择模板
     * @param name {string} 模板名称
     * */
    selectTemplate(name) {
      this.setTemplate(name)
    },
  },
}
</script>

<style lang="scss" scoped>
#temp-list {
  .temp__image {
    width: 128px;
    height: 128px;
    display: block;
    margin: 0 0.5em 1em;
  }
  .tem__image__active {
    border: 2px solid #1598d9;
  }
}
</style>

<style lang="scss"></style>
